import { Platform } from "react-native";
import { Art } from "@components/Collection/Art";
import LBox from "@components/LBox";
import LText from "@components/LText";
import TickBox from "@components/TickBox";
import LPressable from "@components/LPressable";
import type { Theme } from "@theme";

type AddToPlaylistItemProps = {
  disabled?: boolean;
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
  playlist: {
    id: string;
    images: string[] | null;
    songIds: string[];
    title: string;
  };
  sentryEventName?: string;
  subtitleColor?: keyof Theme["colors"];
  titleColor?: keyof Theme["colors"];
};

const AddToPlaylistItem = ({
  disabled,
  isSelected,
  onSelect,
  playlist: { id, images, songIds, title },
  sentryEventName = "add_to_playlist_item",
  subtitleColor,
  titleColor,
}: AddToPlaylistItemProps) => {
  return (
    <LPressable
      sentryEventName={sentryEventName}
      onPress={() => onSelect(!isSelected)}
    >
      <LBox flexDirection="row" mb="s4">
        <LBox mr="s4">
          <Art
            id={id}
            imageUrl={images}
            imageSize="small"
            size={43}
            style={{}}
            type="playlist"
          />
        </LBox>
        <LBox
          alignItems="center"
          flexDirection="row"
          flexGrow={1}
          justifyContent="space-between"
          flexShrink={Platform.OS === "web" ? 1 : undefined}
        >
          <LBox mr="s4" flex={1} flexShrink={1}>
            <LText
              color={titleColor}
              mb="s0_5"
              numberOfLines={1}
              variant="listItem"
            >
              {title}
            </LText>
            <LText
              color={subtitleColor}
              numberOfLines={1}
              variant="listItem-subheader"
            >
              {`${songIds.length} song${songIds.length === 1 ? "" : "s"}`}
            </LText>
          </LBox>
          <TickBox
            disabled={disabled}
            disabledOpacity={0.3}
            on={isSelected}
            toggle={onSelect}
            title={title}
            variant="playlist"
          />
        </LBox>
      </LBox>
    </LPressable>
  );
};

export default AddToPlaylistItem;
